module.exports = __webpack_public_path__ + "files/d1e288052505a7ab669af9fcd047c702.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/roboto-italic-webfont.ttf
 ** module id = 1005
 ** module chunks = 0
 **/